import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const AuthError: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string>("Authentication failed");
  const [errorDetails, setErrorDetails] = useState<string | null>(null);

  useEffect(() => {
    // Extract error message from URL if available
    const error = searchParams.get('error');
    
    if (error) {
      const decodedError = decodeURIComponent(error);
      
      // Handle specific error types
      if (decodedError === 'invalid_state') {
        setErrorMessage('OAuth state validation failed');
        setErrorDetails('The security token for this authentication request was invalid or expired. This typically happens when authentication takes too long or browser cookies are cleared during the process.');
      } else {
        // For other errors, just show the error as-is
        setErrorMessage(decodedError);
      }
    }

    // If we have a timestamp, include it for server log correlation
    const timestamp = searchParams.get('timestamp');
    if (timestamp) {
      const errorTime = new Date(parseInt(timestamp)).toLocaleString();
      setErrorDetails(prev => 
        (prev ? `${prev}\n\n` : '') + `Error occurred at ${errorTime}`
      );
    }

    // Redirect to login after a delay
    const timer = setTimeout(() => {
      navigate('/login');
    }, 8000);
    
    return () => clearTimeout(timer);
  }, [navigate, searchParams]);

  return (
    <div className="auth-error">
      <h2>Authentication Error</h2>
      
      <div className="error-box">
        <p className="error-message">{errorMessage}</p>
        {errorDetails && <p className="error-explanation">{errorDetails}</p>}
      </div>
      
      <p className="error-details">
        <strong>Common causes of authentication errors:</strong>
        <ul>
          <li>Google account permissions were denied</li>
          <li>OAuth session expired or timed out</li>
          <li>Browser cookie settings are too restrictive</li>
          <li>Server connection issues</li>
          <li>Invalid authentication parameters</li>
        </ul>
      </p>
      
      <p>Redirecting you to the login page...</p>
      <button 
        className="button" 
        onClick={() => navigate('/login')}
      >
        Go to Login Now
      </button>
    </div>
  );
};

export default AuthError; 